module.exports = __webpack_public_path__ + "img/map-location-dot.50587355.svg";